module.exports = __webpack_public_path__ + "img/half_red_check.ea9c6df2.svg";